import React, { useEffect, useState, Suspense, lazy } from "react";
import Header from "./components/Header";
//import CallMeForm from './components/CallMeForm';
import Body from "./components/Body";
import axios from "axios";
import Footer from "./components/CommenFooterComponent/index";
import "@fontsource/poppins";
import Contact from "./components/SignUpForm";
import Navbar from "./components/Navbar";
import "./App.css";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";

function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 1);
      const swmcLink = await getHyperLink("websites", "swmc", 0);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
      setSwmcLink(swmcLink, "Sun West ");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div className=" ">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        metaFileDirectory={"."}
      >
        {links ? (
          <>
            <Navbar />
            <Header swmcLink={swmcLink}/>
            <Contact
              sunwestLink={sunwestLink}
              celligenceLlcLink={celligenceLlcLink}
            />
            <Body links={links.current} swmcLink={swmcLink}/>
            <Footer sunwestLink={sunwestLink} />
          </>
        ) : (
          <div>Loading...</div>
        )}
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
      </CacheBuster>
    </div>
  );
}

export default App;
